import {
  withCompInfo,
  createComponentMapperModel,
} from '@wix/editor-elements-integrations';

import type { IWbuCheckboxGroupProps } from '../WbuCheckboxGroup.props';

export const props = withCompInfo<IWbuCheckboxGroupProps, any>()(
  ['compData'],
  ({ compData }) => ({
    ...compData,
  }),
);

export default createComponentMapperModel({
  props,
});
